import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from "lucide-react";
import { appName } from "constants/constants";
import logo from "assets/images/Plentima-Logo.png";

const LoadingScreen = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Check if user is logged in by looking for session token
        const token = localStorage.getItem('token');
        const user = localStorage.getItem('user');
        
        // Add a small delay to show the loading screen
        const timer = setTimeout(() => {
            if (token) {
                const userRole = user ? (JSON.parse(user)?.userRole || '').toLowerCase() : '';
                const isCustomer = userRole === 'customer';
                navigate(isCustomer ? '/customer/dashboard' : '/dashboard');
            } else {
                navigate('/login');
            }
        }, 2000); // 2 second delay

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="flex items-center justify-center min-h-screen bg-slate-50 dark:bg-zink-800">
            <div className="text-center">
                <img 
                    src={logo} 
                    alt={appName} 
                    className="h-16 mx-auto mb-8 animate-pulse"
                />
                <div className="flex items-center justify-center">
                    <Loader2 className="size-8 animate-spin text-purple-500" />
                    <h5 className="mt-2 mb-1 ml-2 text-slate-600 dark:text-zink-200">
                        Loading {appName}...
                    </h5>
                </div>
            </div>
        </div>
    );
};

export default LoadingScreen; 